import { render, staticRenderFns } from "./SettingsMessages.vue?vue&type=template&id=159bb28d"
import script from "./SettingsMessages.vue?vue&type=script&lang=js"
export * from "./SettingsMessages.vue?vue&type=script&lang=js"
import style0 from "./SettingsMessages.vue?vue&type=style&index=0&id=159bb28d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports